import {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Form} from "antd";
import Input from "@/app/components/form-fields/input/Input.jsx";
import Select from "@/app/components/form-fields/select/Select";
import FormContext from "@/app/context/FormContext";
import {countryService} from "@/app/services/CountryService";
import {cityService} from "@/app/services/CityService";
import classes from "../../page.module.scss";
import {linkedinPattern} from "@/app/utils/regexPatterns";
import RoundedButton from "@/app/components/buttons/rounded-button/RoundedButton";

const SecondStepForm = () => {
    const {t} = useTranslation();
    const {secondStep, setSecondStep, next} = useContext(FormContext);
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [error, setError] = useState(null);
    const [query, setQuery] = useState("");
    const [form] = Form.useForm();

    useEffect(() => {
        countryService.getAll(query).then(setCountries).catch(setError);
    }, [query]);

    const countryOptions = countries.map(country => ({
        value: country.id,
        label: country.name,
    }));

    const cityOptions = cities.map(city => ({
        value: city.id,
        label: city.name,
    }));

    const onCountryChange = (value) => {
        if(value) {
            setSelectedCountry(value);
            setSelectedCity(null)
            form.setFieldsValue({city_id: null, city_name: null});
            cityService.getCitiesByCountryId(value.value)
                .then(setCities)
                .catch(setError);
        }else {
            setSelectedCountry(null);
            setSelectedCity(null)
            form.setFieldsValue({city_id: null, city_name: null});
            setQuery('')
        }
    };

    const onCityChange = (value) => {
        setSelectedCity(value);
    };

    const onCitySearch = (searchValue) => {
        if (selectedCountry) {
            cityService.getCitiesByCountryId(selectedCountry.value, searchValue)
                .then(setCities)
                .catch(error => {
                    setCities([]);
                });
        }
    };

    return (
        <>
            <Form
                form={form}
                initialValues={{
                    ...secondStep,
                    country_id: secondStep.country_id === '' ? null : secondStep.country_id,
                    city_id: secondStep.city_id === '' ? null : secondStep.city_id,
                }}
                onFinish={(values) => {
                    setSecondStep(values);
                    next();
                }}
            >
                <Form.Item
                    name="linkedin"
                    rules={[
                        {
                            pattern: linkedinPattern,
                            message: t('validation.linkedinPattern'),
                        },
                    ]}
                >
                    <Input
                        placeholder={t('placeholders.link')}
                    />
                </Form.Item>
                <Form.Item
                    name="position"
                    rules={[
                        {
                            validator: (_, value) => {
                                if (!value.trim() || value.trim().length < 2) {
                                    return Promise.reject(new Error(t("validation.nameLength")));
                                }
                                return Promise.resolve();
                            }
                        },
                        {
                            required: true,
                            whitespace: true,
                            message: t('validation.positionRequired'),
                        },
                        {
                            max: 100,
                        }
                    ]}
                >
                    <Input
                        placeholder={t('placeholders.position')}
                    />
                </Form.Item>
                <Form.Item
                    name="company"
                    rules={[
                        {
                            validator: (_, value) => {
                                if (!value.trim() || value.trim().length < 2) {
                                    return Promise.reject(new Error(t("validation.nameLength")));
                                }
                                return Promise.resolve();
                            }
                        },
                        {
                            required: true,
                            whitespace: true,
                            message: t('validation.companyRequired'),
                        },
                        {
                            max: 100,
                        },
                    ]}
                >
                    <Input
                        placeholder={t('placeholders.company')}
                    />
                </Form.Item>
                <Form.Item
                    name="country_id"
                    rules={[
                        {
                            required: true,
                            message: t('validation.countryRequired'),
                        },
                    ]}
                >
                    <Select
                        placeholder={t('placeholders.country')}
                        onChange={onCountryChange}
                        onSearch={(e) => setQuery(e)}
                        filterOption={() => true}
                        options={countryOptions}
                        labelInValue
                        value={selectedCountry ? selectedCountry : undefined}
                    />
                </Form.Item>
                <Form.Item
                    name="city_id"
                >
                    <Select
                        placeholder={t('placeholders.city')}
                        onChange={onCityChange}
                        onSearch={onCitySearch}
                        disabled={!selectedCountry}
                        options={cityOptions}
                        filterOption={() => true}
                        value={selectedCity}
                        labelInValue
                    />
                </Form.Item>
                <Form.Item
                    name="network"
                    rules={[
                        {
                            min: 3,
                            max: 100,
                            whitespace: true,
                            message: t('validation.networkLength'),
                        },
                    ]}
                >
                    <Input
                        placeholder={t('placeholders.network')}
                    />
                </Form.Item>

                <RoundedButton
                    type="primary"
                    htmlType="submit"
                    className={classes.step_button}

                >{t('buttons.nextStep')}</RoundedButton>
            </Form>
            {/*<div className={classes.link}>
                <a>SKIP this step</a>
            </div> */}
        </>
    )
}

export default SecondStepForm;